// src/com/map/MapFloatingInfo.js
import { styled  } from '@mui/material/styles';

const DefaultValues = {
    containerPadding: 5,
    rowHeight: 36,
    boxWidth: 400,
};

const FloatingInfoContainer = styled('div')({
    position:'fixed',
    display:'inline-block',
    backgroundColor: '#fff',
    borderRadius: 5,
    padding: DefaultValues.containerPadding,
    overflow: 'auto',
    zIndex: 99999,
});

const ContentWrapper = styled('div')({
    display:'block',
    border: '1px solid #ccc'
});

const RowDiv = styled('div')({
    display:'block',
    height: DefaultValues.rowHeight,
    borderBottom: '1px solid #ccc',
    boxSizing: 'border-box',
    '&:last-of-type': {borderBottom: 'none'}
});

const LabelCell = styled('div')({
    display:'inline-flex',
    fontSize: '0.8rem', color: '#77b',
    width: 120, height: '100%',
    // textAlign: 'right',
    paddingRight: 5,
    justifyContent: 'flex-end',
    alignItems: 'center',
    overflow: 'hidden',
    borderRight: '1px solid #ccc', boxSizing: 'border-box'
});

const ValueCell = styled('div')({
    display:'inline-flex',
    fontSize: '0.85rem',
    height: '100%',
    flexGrow: 1,
    paddingLeft: 5,
    alignItems: 'center',
    overflow: 'hidden',
});

export function getFloatingInfoBoxHeight(dataProps, option) {
    const rh = option.rowHeight || DefaultValues.rowHeight;
    const height = dataProps.length * rh + 2 * DefaultValues.containerPadding;
    return height;
}

export default function MapFloatingInfo({
    data, // array of object
    dataProps, // array of {id, label, print}
    option, // {width, rowHeight}
    top,
    left,
    bottom,
}) {
    if(!data || !dataProps) return null;

    const boxStyle = {
        width: option && option.width ? option.width : DefaultValues.boxWidth,
        left: left,
    };
    if(bottom) boxStyle.bottom = bottom;
    else boxStyle.top = top;

    return(
        <FloatingInfoContainer
            style={boxStyle}
        >
            <ContentWrapper>
                {
                    dataProps.map((prop, idx) => {
                        const key = prop.id;
                        const value = data[key];
                        return(
                            <RowDiv key={key} style={{height: option.rowHeight || DefaultValues.rowHeight}}>
                                <LabelCell>{prop.label}</LabelCell>
                                <ValueCell>
                                    {
                                        prop.print ? prop.print(data, value) : value
                                    }
                                </ValueCell>
                            </RowDiv>
                        );
                    })
                }
            </ContentWrapper>
        </FloatingInfoContainer>
    );
}